export default {
  siteName: '果冻传媒',
  siteSlogan: '创意内容营销与品牌传播平台',
  navHome: '首页',
  navCategory: '服务分类',
  navAbout: '关于我们',
  navContact: '联系我们',
  readMore: '阅读更多',
  viewAll: '查看全部',
  backToList: '返回列表',
  contactUs: '联系我们',
  submit: '提交',
  name: '姓名',
  email: '邮箱',
  phone: '电话',
  message: '留言',
  company: '公司名称',
  heroTitle: '用创意内容驱动品牌增长',
  heroSubtitle: '果冻传媒专注创意内容生产与品牌传播，以顶尖创意团队与丰富行业经验，助力品牌实现高效曝光与用户增长',
  heroCTA: '立即咨询',
  serviceTitle: '我们的服务',
  serviceDesc: '全方位创意内容营销解决方案，为品牌量身定制传播策略',
  caseTitle: '精选案例',
  caseDesc: '用作品说话，每一个项目都是我们对创意的极致追求',
  statsClients: '服务客户',
  statsCases: '成功案例',
  statsYears: '行业经验',
  statsTeam: '专业团队',
  testimonialTitle: '客户评价',
  testimonialDesc: '来自合作伙伴的真实反馈',
  ctaTitle: '准备好让您的品牌脱颖而出？',
  ctaSubtitle: '立即联系我们，获取专属品牌传播方案',
  ctaButton: '免费获取方案',
  footerRights: '© 2024 果冻传媒 版权所有',
  footerPrivacy: '隐私政策',
  footerTerms: '服务条款',
  footerContact: '联系方式',
  footerAddress: '北京市朝阳区建国路88号SOHO现代城A座',
  footerPhone: '400-888-9999',
  footerEmail: 'hello@guodongmedia.com',
  categoryShortVideo: '短视频制作',
  categoryBrandMarketing: '品牌营销',
  categoryAdPlanning: '广告策划',
  categorySocialMedia: '社交媒体运营',
  categoryContentCreative: '内容创意',
  categoryFullService: '全案服务',
  aboutTitle: '关于果冻传媒',
  aboutIntro: '品牌介绍',
  aboutHonor: '荣誉资质',
  aboutContact: '联系我们',
  breadcrumbHome: '首页',
  relatedArticles: '相关文章',
  noArticles: '暂无文章',
  searchPlaceholder: '搜索文章...',
};